/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, useContext } from "react";

export interface IModal {
    title: string
    show: boolean
    desc: string
    click: () => void
}

export const InitialModal: IModal = {title: '', show: false, desc: '', click: () => {}}

interface IModalContext{
    modal: IModal
    open: (modal: IModal) => void
    close: () => void
}
export const ModalContext = createContext<IModalContext>({
    modal: InitialModal,
    open: () => {},
    close: () => {},
})


export const useModal = () => useContext(ModalContext)